<template>
	<b-container>

		<b-form @submit.prevent="registerSubmit">
			<legend>Register new user</legend>

			<b-row class="mt-3">

				<b-col>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="First Name:" for="firstname">
						<b-col :md="5">
							<input required id="firstname" type="text" placeholder="First Name" v-model="newUser.FirstName" />
						</b-col>
						<p v-if="validation['model.FirstName']">{{ validation['model.FirstName'][0] }}</p>
					</b-form-group>


					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Last Name:" for="lastname">
						<b-col :md="5">
							<input required id="lastname" type="text" placeholder="Last Name" v-model="newUser.LastName" />
						</b-col>
						<p v-if="validation['model.LastName']">{{ validation['model.LastName'][0] }}</p>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Email:" for="email">
						<b-col :md="5">
							<input required id="email" type="text" placeholder="Email address" v-model="newUser.Email" />
						</b-col>

						<p v-if="validation['model.Email']">{{ validation['model.Email'][0] }}</p>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Password:" for="password">

						<b-col :md="5">
							<input id="password" class="password" v-model="newUser.Password" />
							
							<b-link class="ml-3 btn btn-link" @click.prevent="generatePassword" title="Regenerate password">
								<b-icon font-scale="1.5" icon="arrow-counterclockwise"></b-icon>
							</b-link>

							<b-link class=" ml-3 btn btn-link" @click.prevent="copyToClipboard" title="Copy to clipboard">
								<b-icon font-scale="1.5" icon="clipboard"></b-icon>
							</b-link>
						</b-col>

						<b-col cols="3">

						</b-col>

						<span v-if="copied">Password copied successfuly!</span>

						<p v-if="validation['model.Password']">{{ validation['model.Password'][0] }}</p>

					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" for="password">
						<b-col :md="5">
							<input required id="password" type="hidden" placeholder="Confirm password" v-model="newUser.ConfirmPassword" />
						</b-col>
						<p v-if="validation['model.ConfirmPassword']">{{ validation['model.ConfirmPassword'][0] }}</p>
					</b-form-group>
					


					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Role:" for="role">
						<b-col :md="5">
							<b-form-select id="role" v-model="newUser.Role" :options="roles" class="mt-3">

							</b-form-select>
						</b-col>
					</b-form-group>



				</b-col>

			</b-row>



			<b-col :md="5" offset="4">
				<b-button type="submit" variant="info">Register User</b-button>
			</b-col>

			<div v-if="registering" class="container-loading">Loading...</div>

			<p v-if="registerError">{{ registerError }}</p>
		</b-form>

	</b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
	data() {
		return {
			newUser: {
				FirstName: "",
				LastName: "",
				Email: "",
				Password: "",
				ConfirmPassword: "",
				Role: null,
				Address: {}
			},

			roles: [
				{ value: null, text: "Please select an option" },
				{ value: "super", text: "Super User" },
				{ value: "admin", text: "Administrator" },
				{ value: "serf", text: "User" },
				{ value: "slave", text: "Restricted User" },
			],

			copied: false,
			settings: {
				maxLength: 64,
				maxDigits: 10,
				maxSymbols: 10,
				length: 12,
				digits: 4,
				symbols: 2,
				ambiguous: true,
			}
		};
	},

	computed: {
		...mapState({
			registering: (state) => state.account.registering,
			registerError: (state) => state.account.registerError,
			validation: (state) => state.account.validation,
		}),

		lengthThumbPosition: function () {
			return (((this.settings.length - 6) / (this.settings.maxLength - 6)) * 100);
		},

		digitsThumbPosition: function () {
			return (((this.settings.digits - 0) / (this.settings.maxDigits - 0)) * 100);
		},

		symbolsThumbPosition: function () {
			return (((this.settings.symbols - 0) / (this.settings.maxSymbols - 0)) * 100);
		},

		strength: function () {
			var count = {
				excess: 0,
				upperCase: 0,
				numbers: 0,
				symbols: 0
			};


			var weight = {
				excess: 3,
				upperCase: 4,
				numbers: 5,
				symbols: 5,
				combo: 0,
				flatLower: 0,
				flatNumber: 0
			};

			var strength = {
				text: '',
				score: 0
			};


			var baseScore = 30;

			for (i = 0; i < this.newUser.Password.length; i++) {
				if (this.newUser.Password.charAt(i).match(/[A-Z]/g)) { count.upperCase++; }
				if (this.newUser.Password.charAt(i).match(/[0-9]/g)) { count.numbers++; }
				if (this.newUser.Password.charAt(i).match(/(.*[!,@,#,$,%,^,&,*,?,_,~])/)) { count.symbols++; }
			}

			count.excess = this.newUser.Password.length - 6;

			if (count.upperCase && count.numbers && count.symbols) {
				weight.combo = 25;
			}
			else if ((count.upperCase && count.numbers) || (count.upperCase && count.symbols) || (count.numbers && count.symbols)) {
				weight.combo = 15;
			}

			if (this.newUser.Password.match(/^[\sa-z]+$/)) {
				weight.flatLower = -30;
			}

			if (this.newUser.Password.match(/^[\s0-9]+$/)) {
				weight.flatNumber = -50;
			}

			var score =
				baseScore +
				(count.excess * weight.excess) +
				(count.upperCase * weight.upperCase) +
				(count.numbers * weight.numbers) +
				(count.symbols * weight.symbols) +
				weight.combo + weight.flatLower +
				weight.flatNumber;

			if (score < 30) {
				strength.text = "weak";
				strength.score = 10;
				return strength;
			} else if (score >= 30 && score < 75) {
				strength.text = "average";
				strength.score = 40;
				return strength;
			} else if (score >= 75 && score < 150) {
				strength.text = "strong";
				strength.score = 75;
				return strength;
			} else {
				strength.text = "secure";
				strength.score = 100;
				return strength;
			}
		},

	},

	mounted() {
		this.generatePassword();
	},

	watch: {
		settings: {
			handler: function () {
				this.generatePassword();
			},
			deep: true
		}
	},

	methods: {
		...mapActions(["doRegister"]),

		registerSubmit() {
			// catch is performed in vuex store, sets registerError.
			this.doRegister(this.newUser).then((response) => {
				if (!this.registerError) {
					this.$router.push({ name: 'users' });
				}
			});
		},

		// copy password to clipboard
		copyToClipboard() {
			// we should create a textarea, put the password inside it, select it and finally copy it
			var copyElement = document.createElement("textarea");
			copyElement.style.opacity = '0';
			copyElement.style.position = 'fixed';
			copyElement.textContent = this.newUser.Password;
			var body = document.getElementsByTagName('body')[0];
			body.appendChild(copyElement);
			copyElement.select();
			document.execCommand('copy');
			body.removeChild(copyElement);

			this.copied = true;
			// reset this.copied
			setTimeout(() => {
				this.copied = false;
			}, 750);
		},
		// generate the password
		generatePassword() {
			var lettersSetArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
			var symbolsSetArray = ["=", "+", "-", "^", "?", "!", "%", "&", "*", "$", "#", "^", "@", "|"];
			//var ambiguousSetArray = ["(",")","{","}","[","]","(",")","/","~",";",":",".","<",">"];
			var passwordArray = [];
			var digitsArray = [];
			var digitsPositionArray = [];


			// first, fill the password array with letters, uppercase and lowecase
			for (var i = 0; i < this.settings.length; i++) {
				// get an array for all indexes of the password array
				digitsPositionArray.push(i);

				var upperCase = Math.round(Math.random() * 1);
				if (upperCase === 0) {
					passwordArray[i] = lettersSetArray[Math.floor(Math.random() * lettersSetArray.length)].toUpperCase();
				}
				else {
					passwordArray[i] = lettersSetArray[Math.floor(Math.random() * lettersSetArray.length)];
				}
			}

			// Add digits to password
			for (i = 0; i < this.settings.digits; i++) {
				let digit = Math.round(Math.random() * 9);
				let numberIndex = digitsPositionArray[Math.floor(Math.random() * digitsPositionArray.length)];

				passwordArray[numberIndex] = digit;

				/* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
				since without this step, numbers may override other numbers */

				var j = digitsPositionArray.indexOf(numberIndex);
				if (i != -1) {
					digitsPositionArray.splice(j, 1);
				}
			}

			// add special charachters "symbols"
			for (i = 0; i < this.settings.symbols; i++) {
				var symbol = symbolsSetArray[Math.floor(Math.random() * symbolsSetArray.length)];
				var symbolIndex = digitsPositionArray[Math.floor(Math.random() * digitsPositionArray.length)];

				passwordArray[symbolIndex] = symbol;

				/* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
				since without this step, numbers may override other numbers */

				var j = digitsPositionArray.indexOf(symbolIndex);
				if (i != -1) {
					digitsPositionArray.splice(j, 1);
				}
			}
			this.newUser.Password = passwordArray.join("");
			this.newUser.ConfirmPassword = this.newUser.Password;

		},


	},
};


</script>


// WEBPACK FOOTER //
// src/components/account/register.vue